<template>
    <highcharts
        :options="options"
        :update-args="updateArgs"></highcharts>
</template>

<script>
import {Chart} from 'highcharts-vue'

export default {
    name: "PortfolioChart",

    components: {
        highcharts: Chart
    },

    props: {
        relativeYearPortfolioStartingBalance: {
            type: Array,
            default: () => []
        },
        relativeYearBenchmarkStartingBalance: {
            type: Array,
            default: () => []
        },
        showBenchMark: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        options() {
            return {
                chart: {
                    defaultSeriesType: 'line',
                    height: 270,
                    backgroundColor: 'transparent',
                    plotBackgroundColor: 'transparent'
                },
                series: [{
                    name: 'Portfolio',
                    color: '#38c8af',
                    data: this.relativeYearPortfolioStartingBalance
                }, {
                    name: 'Benchmark',
                    color: '#1d3e85',
                    visible: this.showBenchMark,
                    data: this.relativeYearBenchmarkStartingBalance
                }],
                title: {
                    text: 'Hypothetical Portfolio Trend Line'
                },
                legend: {
                    enabled: true,
                    title: {
                        text: 'Legend'
                    }
                },
                plotOptions: {
                    line: {
                        marker: {
                            enabled: false
                        }
                    }
                },
                yAxis: {
                    labels: {
                        enabled: true
                    },
                    gridLineColor: '#cccccc',
                    min: 0,
                    title: {
                        text: '',
                        enabled: false
                    }
                },
                xAxis: {
                    lineColor: '#cccccc',
                    gridLineColor: 'transparent',
                    title: {
                        text: 'Time'
                    }
                },
                navigator: {
                    enabled: false
                },
                scrollbar: {
                    enabled: false
                },
                rangeSelector: {
                    enabled: false
                },
                exporting: {
                    sourceWidth: 1140,
                    buttons: {
                        contextButton: {
                            enabled: false
                        }
                    }
                }
            }
        }
    },

    data() {
        return {
            updateArgs: [true, true, {duration: 1000}]
        }
    },
}
</script>
